module.exports = __webpack_public_path__ + "img/male-infant-foot.70c73883.svg";